define('models/Podio.Models.Question',['require','underscore','lib/backbone/Backbone.PodioModel','lib/Podio.Config','lib/Podio.Routes','lib/Podio.Transport'],function(require) {

  var _ = require('underscore');
  var PodioModel = require('lib/backbone/Backbone.PodioModel');
  var podioConfig = require('lib/Podio.Config');
  var routes = require('lib/Podio.Routes');

  var transport = require('lib/Podio.Transport');

  return PodioModel.extend({
    highestOptionAnswerCount: function() {
      return _.max(_.values(this.get('answer_counts')));
    },

    progressBarWidthOnOption: function(option) {
      var option_answer_count = this.answerCountOnOption(option);
      var total_answer_count = this.totalAnswerCount();
      var width;

      if (option_answer_count > 0 && total_answer_count) {
        width = (option_answer_count / total_answer_count) * 100;
      }

      return width || 0;
    },

    totalAnswerCount: function() {
      var answerValues = _.values(this.get('answer_counts'));
      return _.reduce(answerValues, function(memo, num) { return memo + num; }, 0);
    },

    answerCountOnOption: function(option) {
      return this.get('answer_counts')[option.question_option_id] || 0;
    },

    isOptionAnswered: function(option) {
      var answer = this.get('answer_by_current_user');
      return (answer && answer.question_option_id === option.question_option_id);
    },

    isOptionLeading: function(option) {
      var result = false;
      var answerCountOnOption = this.answerCountOnOption(option);

      if ((this.totalAnswerCount() === 1) && (answerCountOnOption === 1)) {
        result = true;
      }

      if (this.highestOptionAnswerCount() > 1 &&
          this.highestOptionAnswerCount() === answerCountOnOption) {
        result = true;
      }

      return result;
    },

    initialize: function(options) {
      this.urlAPI = '/question/show/{0}/'.format(this.get('question_id'));
      this.useDirectAPIAccess = true;

      this._super();
    },

    fetchQuestion: function() {
      var self = this;

      return this.request('GET', this.urlAPI).done(function(res) {
        self.set('answer_counts', res.answer_counts);
        self.set('answer_by_current_user', res.answer_by_current_user);
      });
    },

    answer: function(question_option_id, ref_type, ref_id) {
      var question_id = this.get('question_id');

      return transport.postJSON(routes.question_answer_path(question_id), {
        'requestData': {
          'question_id' : question_id,
          'ref_type': ref_type,
          'ref_id': ref_id,
          'question_option_id': question_option_id
        }
      });
    }
  });

});

